// The avatar initials of a business account: the first letter of its first two words, "?" without
// a name. A word that starts with neither a letter nor a digit ("&") is skipped: "Kettle & Co" is
// "KC".
export const getInitials = (name) => {
  const words = (name ?? "")
    .trim()
    .split(/\s+/)
    .filter((word) => /^[\p{L}\p{N}]/u.test(word))

  if (!words.length) return "?"

  return (
    words
      .slice(0, 2)
      // The first character, not the first half of one: "𝐀" or "𠀀" is two UTF-16 units.
      .map((word) => [...word][0].toUpperCase())
      .join("")
  )
}
